import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types'; // ES6
import { Link } from 'react-router';
import { Button, Spin, Card, DatePicker } from 'antd';

import { rutaAvisos } from '../../routes/routeConstants';
import {
    convertirTextAMomentUTC,
    convertirTextAMomentLocal,
    MASCARA_DDMMYYYY
} from '../../commons/gestioDates';
import {
    avisFormulariObtenirDataAvis,
    avisIntroduccioModificarVigilant,
    avisFormulariEnviar,
    usuariObtenirTots,
    onEnterAvisCrear
} from '../../actions';

import AvisIntroduccioSeccioDadesLocalitzacio from './avisIntroduccioSeccioDadesLocalitzacio';
import AvisIntroduccioSeccioDadesMeteor from './avisIntroduccioSeccioDadesMeteor';
import AvisIntroduccioSeccioDadesVigilant from './avisIntroduccioSeccioDadesVigilant';
import PopoverError from '../commons/popoverError';

import seguretatWrapper from '../seguretat/seguretatWrapper';
import { esPotSeleccionarVigilantEnIntroduccioAvis } from '../../commons/callbacksSeguretat';
import { selectorLogin } from '../../selectors/selector_login';
import { selectorObtenirUsuarisVigilants } from '../../selectors/selector_usuari';

import { RETARD_MILISEGONS_APARICIO_SPINNER } from '../../constants';
import errorBoundaryWrapper from '../commons/errorBoundaryWrapper';

const MASCARA_HHmm = 'HH:mm';
const formatDataAMostrar = MASCARA_DDMMYYYY + ' ' + MASCARA_HHmm;

class AvisIntroduccio extends Component {

    constructor(props) {
        super(props);
        this.onClickButtonGuardar = this.onClickButtonGuardar.bind(this);
        this.onChange = this.onChange.bind(this);
        this.esDiaDeshabilitat = this.esDiaDeshabilitat.bind(this);
    }

    componentDidMount() {
        this.props.onEnterAvisCrear();
    }

    onClickButtonGuardar() {
        this.props.avisFormulariEnviar(this.props.router);
    }

    esDiaDeshabilitat(dataCalendari) {
        const dataActual = convertirTextAMomentUTC(this.props.dataActualText);
        return dataCalendari ? dataCalendari.isAfter(dataActual, 'day') : false;
    }

    onChange(dataSeleccionada) {
        const dataAvisText = this.props.dataAvisText;
        const dataAvis = convertirTextAMomentLocal(dataAvisText);

        const dataActualText = this.props.dataActualText;
        const dataActual = convertirTextAMomentLocal(dataActualText);

        if (dataSeleccionada && dataSeleccionada.isAfter(dataActual, 'minute')) {
            this.datepicker.picker.setState({value: dataAvis});
            return;
        }

        if (dataSeleccionada && !dataSeleccionada.isSame(dataAvis, 'minute')) {
            this.props.avisFormulariObtenirDataAvis(dataSeleccionada);
        }

        if (dataSeleccionada === null) { // no es pot deseleccionar al data
            this.datepicker.picker.setState({value: dataAvis});
        }
    }

    render() {
        const { idVigilant, dataAvisText, peticioInserirEnCurs, errorData, errorVigilant, vigilants } = this.props;
        const { avisIntroduccioModificarVigilant, usuariObtenirTots } = this.props;

        if (!idVigilant || !dataAvisText) {
            return null;
        }

        const dataAvis = convertirTextAMomentLocal(dataAvisText);
        const AvisIntroduccioSeccioDadesVigilantAmbSeguretat = seguretatWrapper(AvisIntroduccioSeccioDadesVigilant, esPotSeleccionarVigilantEnIntroduccioAvis);

        return (
            <Spin spinning={peticioInserirEnCurs} delay={RETARD_MILISEGONS_APARICIO_SPINNER}>
                <div className='avis-introduccio-container'>
                    <Card bordered={false}>
                        <div className='avis-introduccio-data-i-vigilant'>
                            <div className='avis-introduccio-data'>
                                <span className='titol'>
                                    Data de l'avís:{errorData ? <PopoverError /> : null}
                                </span>
                                <DatePicker
                                    ref={ (datepicker) => { this.datepicker = datepicker; }}
                                    defaultValue={ dataAvis }
                                    format={ formatDataAMostrar }
                                    onChange={ this.onChange }
                                    disabledDate={ this.esDiaDeshabilitat }
                                    showTime={{ format: MASCARA_HHmm }}
                                    allowClear={ false }
                                />
                            </div>
                            <AvisIntroduccioSeccioDadesVigilantAmbSeguretat
                                idVigilant={idVigilant}
                                errorVigilant={errorVigilant}
                                vigilants={vigilants}
                                avisIntroduccioModificarVigilant={avisIntroduccioModificarVigilant}
                                usuariObtenirTots={usuariObtenirTots}
                            />
                        </div>
                        <div className='avis-introduccio-seccio-dades-localitzacio'>
                            <AvisIntroduccioSeccioDadesLocalitzacio />
                        </div>
                        <div className="avis-introduccio-seccio-dades-meteor">
                            <AvisIntroduccioSeccioDadesMeteor />
                        </div>
                        <div className='avis-introduccio-botons'>
                            <Button size={'large'} type='primary' disabled={peticioInserirEnCurs} onClick={this.onClickButtonGuardar}>
                                Guardar
                            </Button>
                            <Link to={rutaAvisos}>
                                <Button size={'large'} disabled={peticioInserirEnCurs} className='avis-introduccio-boto-cancellar'>
                                    Cancel·lar
                                </Button>
                            </Link>
                        </div>
                    </Card>
                </div>
            </Spin>
        );
    }
}

AvisIntroduccio.propTypes = {
    idVigilant: PropTypes.number,
    idUsuari: PropTypes.number,
    dataActualText: PropTypes.string,
    dataAvisText: PropTypes.string,
    errorData: PropTypes.bool,
    errorVigilant: PropTypes.bool,
    vigilants: PropTypes.array,
    peticioInserirEnCurs: PropTypes.bool,
    avisFormulariObtenirDataAvis: PropTypes.func,
    avisIntroduccioModificarVigilant: PropTypes.func,
    avisFormulariEnviar: PropTypes.func,
    usuariObtenirTots: PropTypes.func,
    router: PropTypes.object,
    onEnterAvisCrear: PropTypes.func
};

const mapStateToProps = (state) => ({
    idVigilant: state.avis.formulari.dades.idVigilant,
    idUsuari: selectorLogin(state).idUsuari,
    dataActualText: state.dataActual,
    dataAvisText: state.avis.formulari.dades.data,
    vigilants: selectorObtenirUsuarisVigilants(state),
    peticioInserirEnCurs: state.avis.formulari.peticioInserirEnCurs,
    errorData: state.avis.formulari.errors.data,
    errorVigilant: state.avis.formulari.errors.idVigilant
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        avisFormulariObtenirDataAvis,
        avisIntroduccioModificarVigilant,
        avisFormulariEnviar,
        usuariObtenirTots,
        onEnterAvisCrear
    }, dispatch);
};

export default errorBoundaryWrapper(connect(mapStateToProps, mapDispatchToProps)(AvisIntroduccio));



// WEBPACK FOOTER //
// ./src/components/avis/avisIntroduccio.js